import { c as PROD_HOSTNAME } from './built-constants-439d5572.js';

var _window;
/**
 * Runtime check for prod environment. Just does a test against the hostname.
 * This is being used as a fallback for `process.env`-set variables
 */

const isProd = ((_window = window) == null ? void 0 : _window.location) && new RegExp(window.location.hostname).test(PROD_HOSTNAME);
/**
 * Runtime check for non-prod environment. Anything other than production is
 * considered development
 */

const isDev = !isProd;

export { isDev as i };
